exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n/* local styles */\n.active[data-v-19071adc] {\n  padding: 5px 5px;\n}\n", ""]);

// exports
